export enum TipoDistribuidora {
  SAESA = 'S',
  EDELAYSEN = 'E',
  FRONTEL = 'F',
}
